import { ContentVideo } from '@centered/types'
import { GetStaticPaths, GetStaticProps } from 'next'
import ReactPlayer from 'react-player'
import HoneyPotPreview from '../../components/honeypots/HoneyPotPreview'
import ShareButton from '../../components/honeypots/ShareButton'
import SEOMetaTags from '../../components/seo/SEOMetaTags'
import Footer from '../../components/shared/Footer'
import Header from '../../components/shared/Header'
import { HEADER_ADJUSTING_STYLES } from '../../components/shared/PageHeader'
import { fetchAllVideos, getVideo } from '../../lib/fetchVideos'
import { baseDomain } from '../../util/baseDomain'

interface VideoPageProps {
  contentVideo: ContentVideo
}

export default function VideoPage({
  contentVideo,
}: VideoPageProps): JSX.Element {
  return (
    <div
      style={{
        ...HEADER_ADJUSTING_STYLES,
      }}
      className="relative"
    >
      <style jsx global>{`
        body {
          background-color: #101010;
          color: white;
        }
      `}</style>

      <SEOMetaTags
        title={contentVideo?.title ?? 'Sukha Blog'}
        url={baseDomain() + `/videos/${contentVideo?.id}`}
        description="Sukha's Productivity Videos"
        imageUrl={`/api/video-og?title=${encodeURIComponent(
          contentVideo?.title,
        )}`}
      />

      <Header noImageBackground={true} disableStickyHeader />

      <div>
        <div className="w-full max-w-5xl px-4 mx-auto pt-10 pb-32">
          <header className="mb-10 relative flex justify-between items-center">
            <h1 className="font-medium text-4xl mb-2">{contentVideo.title}</h1>

            <ShareButton
              title={contentVideo.title}
              link={`/video/${contentVideo.id}`}
            />
          </header>

          <div className="player-wrapper rounded-md overflow-hidden">
            <ReactPlayer
              url={contentVideo.muxUrlWithNoTailLogo}
              width="100%"
              height="100%"
              controls
            />
          </div>

          <HoneyPotPreview />
        </div>
      </div>

      <Footer />
    </div>
  )
}

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const id = (params?.videoId ?? '') as string
  const response = await getVideo(id)

  return {
    props: {
      contentVideo: response.video ?? {},
    },
  }
}

export const getStaticPaths: GetStaticPaths = async () => {
  const response = await fetchAllVideos()

  return {
    paths: response.videos.map((v) => `/video/${v.id}`),
    fallback: false,
  }
}
